import { ChatAnswer, ChatQuota } from '../interfaces/chat-answer';
import { ChatAnswerDto, ChatQuotaDto } from '../interfaces/response-dto';

export class ChatAnswerDataMapper {
  public decode(dto: ChatAnswerDto): ChatAnswer {
    return {
      conversationId: dto.conversationId,
      messageId: dto.messageId,
      answer: dto.answer,
      pendingConfirmation: dto.pendingConfirmation,
      usage: {
        promptTokens: dto.usage.promptTokens,
        completionTokens: dto.usage.completionTokens,
        totalTokens: dto.usage.totalTokens,
        llmCalls: dto.usage.llmCalls,
      },
      quota: this.decodeQuota(dto.quota),
    };
  }

  private decodeQuota(dto: ChatQuotaDto | null): ChatQuota | null {
    if (!dto) {
      return null;
    }

    return {
      period: dto.period,
      limitTokens: dto.limitTokens,
      totalSpentTokens: dto.totalSpentTokens,
      remainingTokens: dto.remainingTokens,
    };
  }
}
